import { Box, FormControl, MenuItem, Select, Typography, IconButton } from "@mui/material"
import { DeleteRounded } from "resource/muiImport"

export const existingMappingsColumns = (sourceSiteAbbr, onRemoveMapping, showDeleteAction = true) => {
  const columns = [
    {
      field: "sourceExpName",
      headerName: `รายการจาก ${sourceSiteAbbr}`,
      flex: 1,
      minWidth: 200
    },
    {
      field: "currentExpName", 
      headerName: "รายการในระบบปัจจุบัน",
      flex: 1,
      minWidth: 200
    }
  ]

  if (showDeleteAction) {
    columns.push({
      field: "actions",
      headerName: "จัดการ",
      width: 80,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          size="small"
          color="default"
          onClick={() => onRemoveMapping && onRemoveMapping(params.row)}
          title="ลบการเชื่อมโยง"
        >
          <DeleteRounded />
        </IconButton>
      )
    })
  }

  return columns
}

export const unmappedExpensesColumns = (sourceSiteAbbr, mappings, handleMappingChange, availableExpenses) => [
  {
    field: "expNm",
    headerName: `รายการจาก ${sourceSiteAbbr}`,
    flex: 1,
    minWidth: 200,
    renderCell: (params) => (
      <Box>
        <Typography variant="body2" fontWeight="bold">
          {params.row.expNm}
        </Typography>
        {params.row.expNmEn && (
          <Typography variant="caption" color="text.secondary" display="block">
            {params.row.expNmEn}
          </Typography>
        )}
      </Box>
    )
  },
  {
    field: "mapping",
    headerName: "รายการในระบบปัจจุบัน",
    flex: 1,
    minWidth: 250,
    renderCell: (params) => (
      <FormControl fullWidth size="small">
        <Select
          value={mappings[params.row.sourceExpId] || ''}
          onChange={(e) => handleMappingChange(params.row.sourceExpId, e.target.value)}
          displayEmpty
        >
          <MenuItem value="">
            <em>-- กรุณาเลือก --</em>
          </MenuItem>
          <MenuItem value="CREATE_NEW" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
            + สร้างรายการใหม่: {params.row.expNm}
          </MenuItem>
          {availableExpenses.map((avail) => (
            <MenuItem key={avail.ExpId} value={avail.ExpId}>
              {avail.ExpNm} {avail.ExpNmEn && `(${avail.ExpNmEn})`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }
]